import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const menuItems = [{
  name: 'Thai Basil Mussels',
  description: 'Fresh mussels in a rich coconut curry broth, Thai basil, chilies, grilled crostini.',
  image: 'https://cdn.magicpatterns.com/uploads/4g6boGxd61Rh4ngPiNSqbH/FB_IMG_1777431836762.jpg'
}, {
  name: 'Lobster Laksa',
  description: 'Whole lobster tail, egg noodles, spicy coconut curry, shrimp, fresh cilantro.',
  image: 'https://cdn.magicpatterns.com/uploads/toocnSc6qbTaT2uP91vZB9/FB_IMG_1777431839477.jpg'
}, {
  name: 'Seared Ahi Tuna Salad',
  description: 'Sesame-crusted ahi tuna, crispy wonton chips, mixed greens, ginger vinaigrette.',
  image: 'https://cdn.magicpatterns.com/uploads/qpy1UmjBvE61rkPqUUmcJ6/FB_IMG_1777431859552.jpg'
}, {
  name: 'Lamb Rack & Pineapple Fried Rice',
  description: 'Herb-crusted lamb chops, pineapple fried rice served in a fresh pineapple, chimichurri.',
  image: 'https://cdn.magicpatterns.com/uploads/fjU2H6gR6BZycWav8BTH6D/FB_IMG_1777431855857.jpg'
}, {
  name: 'Lobster & Bone Marrow Bowl',
  description: 'Whole lobster, roasted bone marrow, scallions, rich umami broth.',
  image: 'https://cdn.magicpatterns.com/uploads/iEQKWyfCgNPw5ZoCyftTLA/FB_IMG_1777431841973.jpg'
}];
export function MenuHighlights() {
  return <section id="menu" className="py-24 bg-cream relative" data-id="element-210">
      {/* Subtle brick accent on the left edge for large screens */}
      <div className="hidden xl:block absolute left-0 top-0 bottom-0 w-8 brick-pattern opacity-40 shadow-[inset_-4px_0_10px_rgba(0,0,0,0.1)]" data-id="element-211"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <span className="text-amber font-medium tracking-widest uppercase text-sm mb-2 block" data-id="element-214">
            Taste the Fusion
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal" data-id="element-215">
            Menu Highlights
          </h2>
          <div className="w-24 h-1 bg-warm-brown mx-auto mt-6" data-id="element-216"></div>
        </div>

        {/* Featured Dish - Large */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-217">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 group overflow-hidden shadow-xl" data-id="element-218">
            <div className="aspect-square relative overflow-hidden" data-id="element-219">
              <img src={menuItems[0].image} alt={menuItems[0].name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-220" />
            </div>
            <div className="bg-charcoal flex items-center p-8 md:p-12 relative" data-id="element-221">
              <div className="absolute inset-0 brick-pattern opacity-5" data-id="element-222"></div>
              <div className="relative z-10" data-id="element-223">
                <span className="text-amber text-sm tracking-widest uppercase font-medium" data-id="element-224">
                  Featured
                </span>
                <h3 className="font-serif text-3xl md:text-4xl text-cream mt-3 mb-4" data-id="element-225">
                  {menuItems[0].name}
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-226">
                  {menuItems[0].description}
                </p>
                <div className="w-12 h-1 bg-warm-brown mt-6" data-id="element-227"></div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Dish Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-228">
          {menuItems.slice(1).map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group" data-id="element-229">
              <div className="aspect-square relative overflow-hidden shadow-lg" data-id="element-230">
                <img src={item.image} alt={item.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-231" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-232"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-233">
                  <h3 className="font-serif text-lg text-cream mb-1" data-id="element-234">
                    {item.name}
                  </h3>
                  <p className="text-gray-300 text-xs leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-235">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-236">
          <Link to="/menu" className="inline-block border border-charcoal text-charcoal px-8 py-3 font-medium tracking-wide uppercase text-sm hover:bg-charcoal hover:text-cream transition-colors" data-id="element-237">
            View Full Menu
          </Link>
        </div>
      </div>
    </section>;
}